// eslint-disable-next-line @typescript-eslint/triple-slash-reference


import { showToast } from '@/components/Toast';
import md5 from '@/common/js/md5.js'
// import { imgUrl } from '@/config'

// import { computed,reactive } from 'vue'
// import { useUserStore, useOtherStore } from '@/store'
// import { storeToRefs } from 'pinia';

let debounceTimer: NodeJS.Timeout | null = null
let throttleTimer: NodeJS.Timeout | null = null

// const { saveIdfa } = useUserStore()
// const { token, userInfo, idfa } = storeToRefs(useUserStore())


/**
 * 获取链接上的参数
 * @returns 
 */
const getRawUrlObj = (url: string = window.location.href) => {
    if (url.includes('?')) {
        const obj = JSON.parse('{"' + decodeURIComponent(url.split("?")[1]).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}');
        return obj
    } else {
        return {}
    }
}





/**
 *
 * @param fn 要执行的函数
 * @param awit  时间
 * @param immediate 是否在触发事件后 在时间段n开始，立即执行，否则是时间段n结束，才执行
 */
const debounce = (fn: any, awit = 500, immediate = false) => {
    return (...args: any) => {
        debounceTimer && clearTimeout(debounceTimer)
        if (immediate) {
            if (!debounceTimer) fn.apply(this, args);
            debounceTimer = setTimeout(function () {//n 秒内 多次触发事件,重新计算.timeer
                debounceTimer = null;//n 秒内没有触发事件 timeer 设置为null，保证了n 秒后能重新触发事件 flag = true = !timmer
            }, awit)
        } else {
            debounceTimer = setTimeout(() => { fn.apply(this, args) }, awit)
        }
    }
}
/**
 * 
 * @param fn 
 * @param awit 
 * @param immediate true 是启用时间戳版，false 是启用定时器版，作用一样
 */
const throttle = (fn: any, awit = 500, immediate = false) => {
    //时间戳
    if (immediate) {
        let prevTime = 0;
        return (...args: any) => {
            const nowTime = Date.now();
            if (nowTime - prevTime >= awit) {
                fn.apply(this, args)
                prevTime = nowTime
            }
        }
    } else {
        //定时器
        return (...args: any) => {
            if (!throttleTimer) {
                fn.apply(this, args)
                throttleTimer = setTimeout(() => {
                    throttleTimer && clearTimeout(throttleTimer)
                    throttleTimer = null
                }, awit);
            }
        }
    }
}

// /**
//  * 根据环境切换的图片地址
//  * @param name 图片名
//  * @returns 地址
//  */
// const tranformImgUrl = (name: string): string => {
//     if (imgUrl.includes("//")) {
//         return `${imgUrl}/${name}`;
//     } else {
//         return require(`public/assets/${name}`);
//     }
// }












/**
 * 生成idfa
 * @returns 
 */
const getIdfa = () => {
    // 缓存 再到 链接 再到 自己生成
    let idfa
    const storage = window.localStorage.getItem('MSDK_idfa')
    if (storage) {
        idfa = storage
    } else {
        const urlObj = getRawUrlObj()
        if (urlObj.idfa) {
            idfa = urlObj.idfa
        } else {
            const myDate = new Date();
            idfa = 'h5';
            const num = parseInt((Math.random() * (9999999999 - 1)).toString(), 10);
            idfa += myDate.getFullYear();
            idfa += '-' + (myDate.getMonth() + 1);
            idfa += '-' + myDate.getDate();
            idfa += '-' + myDate.getHours();
            idfa += '-' + myDate.getMinutes();
            idfa += '-' + myDate.getSeconds();
            idfa += '-' + num;
        }
        window.localStorage.setItem('MSDK_idfa', idfa)
    }
    return idfa;
}



/**
 * 把时间戳转换成年月日
 * @param timestamp 
 * @returns 
 */
const getDate = (timestamp: number) => {
    const date = new Date(timestamp * 1000);
    const today = new Date();
    const tomorrow = new Date();
    const afterTomorrow = new Date();

    tomorrow.setDate(today.getDate() + 1);
    afterTomorrow.setDate(today.getDate() + 2);

    const Y = date.getFullYear() + '-';
    const M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
    const D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' ';
    const h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
    const m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
    const s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();

    return Y + M + D
}





/**
 * 把时间戳转换成当前日期的 今天 明天 后天的相对日期
 * @param timestamp 
 * @returns 
 */
const getRelativeDate = (timestamp: number) => {
    const date = new Date(timestamp * 1000);
    const today = new Date();
    const tomorrow = new Date();
    const afterTomorrow = new Date();

    tomorrow.setDate(today.getDate() + 1);
    afterTomorrow.setDate(today.getDate() + 2);

    const Y = date.getFullYear() + '-';
    const M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
    const D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' ';
    const h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
    const m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
    const s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();

    if (timestamp < Date.now() / 1000) {
        return Y + M + D
    }
    if (date.toDateString() === today.toDateString()) {
        return `今天${h + m}`;
    } else if (date.toDateString() === tomorrow.toDateString()) {
        return `明天${h + m}`;
    } else if (date.toDateString() === afterTomorrow.toDateString()) {
        return `后天${h + m}`;
    } else {
        return '即将';
    }
}















/**
 * 对象添加sign
 * @param obj 要添加签名的对象
 * @returns 
 */
const signFn = <T extends ObjType>(obj: T): T & { sign: string } => {
    if (obj.xhDebugger) {
        delete obj.xhDebugger
    }
    //这个参数是判断是微端的参数，在微端的链接那里加的
    if (obj.miniClient) {
        delete obj.miniClient
    }
    const sign = querySort(obj)
    const data = {
        ...obj,
        sign
    }
    return data
}
// 签名
const querySort = (queryObj: ObjType, noMd5?: boolean): string => {
    const keyArr = Object.keys(queryObj);
    let str = '';
    // 兼容低端安卓机
    if (!Array.prototype.findIndex) {
        Array.prototype.findIndex = function (predicate) {
            if (this == null) {
                throw new TypeError('Array.prototype.findIndex called on null or undefined');
            }
            if (typeof predicate !== 'function') {
                throw new TypeError('predicate must be a function');
            }
            const list = Object(this);
            const length = list.length >>> 0;
            // eslint-disable-next-line prefer-rest-params
            const thisArg = arguments[1];
            let value;
            for (let i = 0; i < length; i++) {
                value = list[i];
                if (predicate.call(thisArg, value, i, list)) {
                    return i;
                }
            }
            return -1;
        }
    }
    keyArr.indexOf('sign') > -1 ? keyArr.splice(keyArr.findIndex(item => item === 'sign'), 1) : ''
    keyArr.sort();
    for (let i = 0; i < keyArr.length; i += 1) {
        if (queryObj[keyArr[i]] !== 0 && queryObj[keyArr[i]]) {
            str = `${str}&${keyArr[i]}=${queryObj[keyArr[i]]}`;
        }
    }
    // console.log('xhh5签名前的串：', str);
    if (noMd5) {
        return `${str.substr(1)}`;
    } else {
        return md5(`${str.substr(1)}&`);
    }
}

/**
 * 获取md5
 * @param {*} target 
 */
const getMd5 = (target: string): string => {
    return md5(target);
}














/**
 * 获取操作系统
 * @returns 安卓 ios pc
 */
const getOS = () => {
    const u = navigator.userAgent
    const hasTouch = navigator.maxTouchPoints > 1

    const rules = [
        { key: 'android', test: () => /android|linux/i.test(u) && !/iPad|iPhone/i.test(u) },
        { key: 'ipad', test: () => /iPad/i.test(u) || (/Macintosh/i.test(u) && hasTouch) },
        { key: 'ios', test: () => /iPhone|iPod/i.test(u) },
        { key: 'mac', test: () => /Mac OS X/i.test(u) && !(/iPhone|iPad/i.test(u)) && !hasTouch },
        { key: 'windows', test: () => /Windows|Win32|Win64/i.test(u) },
    ]

    return rules.find(rule => rule.test())?.key || 'unknown'
}

//判断
const getEntryView = () => {
    const rules: Array<{ condition: boolean; value: 'android' | 'ios' | 'H5SDK' | '' }> = [
        { condition: !!window.xhWebUtils, value: 'android' },
        { condition: !!window.webkit?.messageHandlers, value: 'ios' },
        { condition: new URL(window.location.href).searchParams.get('isH5SDK') === '1', value: 'H5SDK' },
    ];
    const hitRule = rules.find(item => item.condition);
    return hitRule?.value ?? '';
}

/**
 * 检测设备类型
 * @returns 'pc' | 'mobile' | 'tablet' | 'unknown'
 */
const detectDevice = (): 'pc' | 'mobile' | 'tablet' | 'unknown' => {
    if (typeof window === 'undefined' || typeof navigator === 'undefined') {
        return 'unknown';
    }

    const ua = (navigator.userAgent || navigator.vendor || (window as any).opera || '').toLowerCase();
    const maxTouch = (navigator as any).maxTouchPoints || 0;
    const hasTouch = ('ontouchstart' in window) || maxTouch > 0;
    // 只用视口宽度，去掉物理屏幕screen.width干扰
    const viewportWidth = window.innerWidth ?? 0;

    // 正则缓存，避免重复test
    const tabletRe = /\b(ipad|tablet|playbook|silk|kindle|kf[a-z]+|sm-t|xoom|gt-p|nexus 7|nexus 9|tab)\b/i;
    const mobileRe = /\b(mobi|iphone|ipod|android|windows phone|blackberry|bb10|opera mini)\b/i;

    const isUA_Tablet = tabletRe.test(ua);
    const isUA_Mobile = mobileRe.test(ua) && !isUA_Tablet;

    // iPadOS新版兼容：UA是Mac + 多点触控 = iPad平板
    const isNewIPad = /macintosh/.test(ua) && hasTouch && maxTouch > 1;

    // 优先级第一步：优先UA判断（最准）
    let type: 'pc' | 'mobile' | 'tablet' | 'unknown' = 'pc';
    if (isUA_Tablet || isNewIPad) {
        type = 'tablet';
    } else if (isUA_Mobile) {
        type = 'mobile';
    }

    // 只有UA完全识别不出来的时候，才降级用视口+触控辅助判断
    // 触屏笔记本电脑排除：触控 + 大屏 >1200px 默认PC
    if (type === 'pc' && hasTouch && viewportWidth > 0) {
        if (viewportWidth < 768) {
            type = 'mobile';
        } else if (viewportWidth >= 768 && viewportWidth <= 1200) {
            // 二合一触屏笔记本，不强制改成平板，可选
            // type = 'tablet'
        }
    }

    return type;
};





/**
 * 判断是否是微信浏览器
 * @returns 
 */
const isWeixin = () => {
    const ua = navigator.userAgent.toLowerCase() as any;
    if (ua.match(/MicroMessenger/i) == 'micromessenger') {
        return true;
    }
    return false;
}





















// 跳转到公众号
const toWxPublic = () => {
    const elseUrl = "https://mp.weixin.qq.com/s?__biz=MzkxOTM5NDQ0OQ==&mid=2247483662&idx=1&sn=227f30deb86448d118739651cdeadc8d&chksm=c1a380f0f6d409e6a559ba415632f876a247261bc80a6906279ed7b66698ee246c9104fc43eb#rd"
    const wxUrl = 'https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=MzkxOTM5NDQ0OQ==&scene=110#wechat_redirect'
    // const { miniClient } = storeToRefs(useOtherStore())
    // if (miniClient.value) {
    //     // 微端的情况下,跳转到小程序
    //     const shares: any = {};
    //     (window as any).plus.share.getServices(function (s: any) {
    //         for (const i in s) {
    //             const t = s[i];
    //             shares[t.id] = t;
    //         }
    //     }, function (e: any) {
    //         (window as any).outSet('获取分享服务列表失败：' + e.message);
    //     });
    //     setTimeout(() => {
    //         if (!shares['weixin']) {
    //             (window as any).plus.nativeUI.toast('未配置微信分享模块!');
    //             return;
    //         }
    //         shares['weixin'].launchMiniProgram({
    //             id: 'gh_1bc7049eecd4', // 小程序原始ID
    //             type: 0, /// 0正式版 1开发版 2体验版
    //             path: `page/wxPublic/index?url=${encodeURIComponent(wxUrl)}` // 指定页的路径，如需传参直接字符串拼接（首页可以省略）
    //         });
    //     }, 500)
    // } else {
    // H5的情况下
    window.open(isWeixin() ? wxUrl : elseUrl)
    // }
}

/**
 * H5端的复制逻辑
 */
const copyFn = (obj: { copyStr: string, tipsStr?: string }) => {
    const { copyStr, tipsStr } = obj
    if (!copyStr) {
        console.log('复制的内容为空 !')
        return;
    }
    if (!document.queryCommandSupported('copy')) { //为了兼容有些浏览器 queryCommandSupported 的判断
        // 不支持
        console.log('浏览器不支持')
        return;
    }
    const textarea = document.createElement("textarea")
    textarea.value = copyStr
    textarea.readOnly = true
    document.body.appendChild(textarea)
    textarea.select() // 选择对象
    textarea.setSelectionRange(0, copyStr.length) //核心
    const result = document.execCommand("copy") // 执行浏览器复制命令
    if (result) {
        console.log("复制成功~")
        showToast({
            type: 'success',
            content: tipsStr || '复制成功'
        })


    } else {
        showToast({
            type: 'error',
            content: '复制失败'
        })
        // console.log("复制失败，请检查h5中调用该方法的方式，是不是用户点击的方式调用的，如果不是请改为用户点击的方式触发该方法，因为h5中安全性，不能js直接调用！")
    }
    textarea.remove()
}

/**
 * 添加外部js
 * @param url js地址
 * @returns 
 */
const loadScript = (url: string): Promise<any> => {
    return new Promise((resolve, reject) => {
        const script = document.createElement('script')
        script.type = 'text/javascript'
        script.src = url
        script.onload = () => resolve({ code: 200 })
        script.onerror = () => reject(new Error(`加载脚本失败: ${url}`))
        document.head.appendChild(script)

    })
}

export {
    debounce,
    throttle,

    getDate,
    getRelativeDate,
    // tranformImgUrl as imgUrl,

    getRawUrlObj,
    signFn,
    getMd5,

    // system
    getIdfa,
    getOS,
    getEntryView,
    isWeixin,
    detectDevice,

    toWxPublic,
    copyFn,
    loadScript
}